const types = {
  THROW_API_ERROR: '@@PO_api/THROW_API_ERROR',
};

export default types;
